<template>
  <b-modal
    id="readme-modal"
    hide-footer
    :no-close-on-backdrop="false"
    scrollable
    centered
    size="lg"
    modal-class="modal-global layout-modal-860"
    header-class="w-100 clear-border pb-0 pt-19 px-18"
    body-class="text-left px-0 pb-0 clear-border"
    content-class="border-radius-12 clear-border"
    @shown="onShown"
  >
    <template #modal-header>
      <div class="d-flex w-100 align-items-center justify-content-between">
        <h5 class="modal-title fs-18 f-600 cl-1c1c1e mb-0">コンテクスト登録</h5>
        <div
          class="close-modal-icon"
          style="cursor: pointer"
          @click="closeModal"
        >
          <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.04883 9.1811C0.737793 9.49213 0.731445 10.0444 1.05518 10.3681C1.38525 10.6918 1.9375 10.6855 2.24219 10.3808L6 6.62299L9.75146 10.3745C10.0688 10.6918 10.6147 10.6918 10.9385 10.3681C11.2622 10.038 11.2622 9.49848 10.9448 9.1811L7.19336 5.42963L10.9448 1.67182C11.2622 1.35444 11.2686 0.808539 10.9385 0.484808C10.6147 0.161078 10.0688 0.161078 9.75146 0.47846L6 4.22993L2.24219 0.47846C1.9375 0.167425 1.37891 0.15473 1.05518 0.484808C0.731445 0.808539 0.737793 1.36713 1.04883 1.67182L4.80029 5.42963L1.04883 9.1811Z"
              fill="#818181"
            />
          </svg>
        </div>
      </div>
    </template>
    <template #default>
      <div class="readme-modal-body">
        <div v-if="showRequiredNotice" class="required-notice">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#c9a800"/>
          </svg>
          <span>チャットを開始するには、先にコンテクストの登録が必要です。保存するとチャットが開始されます。</span>
        </div>
        <p class="readme-modal-desc">
          あなたの商材情報を登録してください。AIの実行時に呼び出すことができます。
        </p>

        <div class="readme-layout">
          <div class="readme-sidebar">
            <!-- 組織コンテクスト（閲覧のみ） -->
            <template v-if="organizationContexts.length > 0">
              <div class="readme-sidebar-section">組織コンテクスト</div>
              <div
                v-for="org in organizationContexts"
                :key="'org-' + org.id"
                class="readme-sidebar-item"
                :class="{ 'readme-sidebar-item--active': selectedType === 'org' && selectedId === org.id }"
                @click="selectOrgContext(org)"
              >
                <button
                  class="readme-main-btn"
                  :class="{ 'readme-main-btn--active': org.is_main }"
                  @click.stop="setMainOrg(org)"
                  :title="org.is_main ? '設定中のコンテクスト' : 'このコンテクストを設定する'"
                >{{ org.is_main ? '設定中' : '設定' }}</button>
                <svg class="readme-sidebar-item__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <!-- building icon -->
                  <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="#798b96"/>
                </svg>
                <div class="readme-sidebar-item__info">
                  <span class="readme-sidebar-item__title">{{ org.title || '組織共通情報' }}</span>
                </div>
              </div>
            </template>

            <div class="readme-sidebar-section">個人コンテクスト</div>

            <div
              v-for="readme in readmes"
              :key="readme.id || readme._tempId"
              class="readme-sidebar-item"
              :class="{ 'readme-sidebar-item--active': selectedType === 'user' && selectedId === (readme.id || readme._tempId) }"
              @click="selectReadme(readme)"
            >
              <button
                class="readme-main-btn"
                :class="{ 'readme-main-btn--active': readme.is_main }"
                @click.stop="setMain(readme)"
                :title="readme.is_main ? '設定中のコンテクスト' : 'このコンテクストを設定する'"
              >{{ readme.is_main ? '設定中' : '設定' }}</button>
              <svg class="readme-sidebar-item__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 2l5 5h-5V4zM6 20V4h5v7h7v9H6z" fill="#798b96"/>
              </svg>
              <div class="readme-sidebar-item__info">
                <span class="readme-sidebar-item__title">{{ readme.title || '商品情報' }}</span>
              </div>
            </div>
            <button class="readme-add-btn" @click="addNewReadme">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
              </svg>
              新しいコンテクストを追加
            </button>
          </div>

          <div class="readme-editor">
            <!-- 組織コンテクスト：閲覧のみ -->
            <div v-if="selectedType === 'org' && currentOrgContext" class="readme-editor__inner">
              <div class="readme-org-notice">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#4a6b8a"/>
                </svg>
                組織共通のコンテクストです。AI実行時に自動で読み込まれます（閲覧のみ・編集不可）。
              </div>
              <div class="readme-title-readonly">{{ currentOrgContext.title || '組織共通情報' }}</div>
              <div class="readme-content-readonly">{{ currentOrgContext.content }}</div>
            </div>
            <!-- 個人コンテクスト：編集可 -->
            <div v-else-if="selectedType === 'user' && currentReadme" class="readme-editor__inner">
              <input
                v-model="currentReadme.title"
                class="readme-title-input"
                type="text"
                placeholder="商品情報"
              />
              <textarea
                v-model="currentReadme.content"
                class="readme-textarea"
                :placeholder="placeholderText"
                rows="12"
              ></textarea>
            </div>
            <div v-else class="readme-editor__empty">
              <p>左のリストからコンテクストを選択するか、新しく追加してください。</p>
            </div>
          </div>
        </div>

        <div class="readme-footer">
          <button
            v-if="selectedType === 'user' && currentReadme && readmes.length > 1"
            class="readme-delete-btn"
            @click="deleteCurrentReadme"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
            </svg>
            削除
          </button>
          <span v-else></span>
          <div class="readme-footer__actions">
            <transition name="readme-saved-fade">
              <span v-if="savedMessage" class="readme-saved-message">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
                </svg>
                {{ savedMessage }}
              </span>
            </transition>
            <button class="readme-cancel-btn" @click="closeModal">キャンセル</button>
            <button
              v-if="selectedType === 'user'"
              class="readme-save-btn"
              :disabled="isSaving || !canSave"
              @click="save"
            >{{ isSaving ? '保存中...' : '保存' }}</button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'
import UserReadmeModel from '@/model/userReadme'
import type { UserReadme } from '@/model/userReadme/schema'
import type { OrganizationContext } from '@/model/userReadme'

type EditableReadme = UserReadme & { _tempId?: string; _isNew?: boolean }
type SelectedType = 'user' | 'org'

let tempIdCounter = 0

@Component({})
export default class UserReadmeModal extends Vue {
  @Prop({ default: false }) showRequiredNotice!: boolean

  readmes: EditableReadme[] = []
  organizationContexts: OrganizationContext[] = []
  selectedType: SelectedType = 'user'
  selectedId: number | string = 0
  isSaving = false
  savedMessage = ''
  savedMessageTimer: number | null = null

  get currentReadme(): EditableReadme | null {
    if (this.selectedType !== 'user') return null
    return this.readmes.find(r => (r.id || r._tempId) === this.selectedId) || null
  }

  get currentOrgContext(): OrganizationContext | null {
    if (this.selectedType !== 'org') return null
    return this.organizationContexts.find(o => o.id === this.selectedId) || null
  }

  get canSave(): boolean {
    if (!this.currentReadme) return false
    return this.currentReadme.content.trim().length > 0
  }

  get placeholderText(): string {
    return [
      '以下のような商材情報を自由にご記入ください。',
      '',
      '【商品名】',
      '【カテゴリ】',
      '【ターゲット】',
      '【価格帯】',
      '【主な機能】',
      '【競合】',
      '【強み】'
    ].join('\n')
  }

  async onShown() {
    // 組織コンテクストは閲覧専用なのでベストエフォートで取得（失敗しても本機能は継続）
    try {
      this.organizationContexts = await UserReadmeModel.fetchOrganizationContexts()
    } catch (e) {
      console.warn('Failed to fetch organization contexts:', e)
      this.organizationContexts = []
    }

    try {
      const readmes = await UserReadmeModel.fetchReadmes()
      if (readmes.length > 0) {
        this.readmes = readmes.map(r => ({ ...r }))
        this.selectedType = 'user'
        this.selectedId = readmes[0].id
      } else {
        this.readmes = []
        this.addNewReadme()
      }
    } catch (e) {
      console.error('Failed to fetch readmes:', e)
      this.addNewReadme()
    }
  }

  selectReadme(readme: EditableReadme) {
    this.selectedType = 'user'
    this.selectedId = readme.id || readme._tempId!
  }

  selectOrgContext(org: OrganizationContext) {
    this.selectedType = 'org'
    this.selectedId = org.id
  }

  // フッターに完了メッセージを数秒だけ表示する（保存・設定切替の操作フィードバック）
  showSavedMessage(text: string) {
    this.savedMessage = text
    if (this.savedMessageTimer) {
      window.clearTimeout(this.savedMessageTimer)
    }
    this.savedMessageTimer = window.setTimeout(() => {
      this.savedMessage = ''
      this.savedMessageTimer = null
    }, 2500)
  }

  async setMain(readme: EditableReadme) {
    // 個人readmeを設定中に → 組織は全部解除、個人は1個に絞る
    // 新規(_isNew)はまだIDが無いので、サーバ呼び出しは保存後にしか出来ない → ローカルでだけ反映
    this.readmes.forEach(r => { r.is_main = false })
    this.organizationContexts.forEach(o => { o.is_main = false })
    readme.is_main = true
    if (readme.id && !readme._isNew) {
      try {
        await UserReadmeModel.setMainContext('user', readme.id)
        this.showSavedMessage('設定しました')
      } catch (e) {
        console.error('Failed to set main context:', e)
      }
    }
  }

  async setMainOrg(org: OrganizationContext) {
    // 組織コンテクストを設定中に → 個人は全部解除、組織のみ true（現状仕様で組織は最大1件）
    this.readmes.forEach(r => { r.is_main = false })
    this.organizationContexts.forEach(o => { o.is_main = false })
    org.is_main = true
    try {
      await UserReadmeModel.setMainContext('org', org.id)
      this.showSavedMessage('設定しました')
    } catch (e) {
      console.error('Failed to set main org context:', e)
    }
  }

  addNewReadme() {
    const tempId = `_new_${++tempIdCounter}`
    const isFirst = this.readmes.length === 0
    const newReadme: EditableReadme = {
      id: 0,
      title: '',
      content: '',
      is_main: isFirst,
      updated_at: '',
      _tempId: tempId,
      _isNew: true
    }
    this.readmes.push(newReadme)
    this.selectedType = 'user'
    this.selectedId = tempId
  }

  async deleteCurrentReadme() {
    if (!this.currentReadme) return
    if (!confirm('このコンテクストを削除しますか？')) return

    const readme = this.currentReadme
    if (readme.id && !readme._isNew) {
      try {
        await UserReadmeModel.deleteReadme(readme.id)
      } catch (e) {
        console.error('Failed to delete readme:', e)
        alert('削除に失敗しました。')
        return
      }
    }

    const idx = this.readmes.findIndex(r => (r.id || r._tempId) === this.selectedId)
    this.readmes.splice(idx, 1)

    if (readme.is_main && this.readmes.length > 0) {
      this.readmes[0].is_main = true
    }

    if (this.readmes.length > 0) {
      this.selectedId = this.readmes[0].id || this.readmes[0]._tempId!
    } else {
      this.addNewReadme()
    }
  }

  async save() {
    if (this.isSaving || !this.canSave || !this.currentReadme) return
    this.isSaving = true

    try {
      const readme = this.currentReadme
      const title = readme.title.trim() || '商品情報'

      if (readme._isNew || !readme.id) {
        const created = await UserReadmeModel.createReadme(title, readme.content, readme.is_main)
        readme.id = created.id
        readme.title = created.title
        readme.updated_at = created.updated_at
        readme.is_main = created.is_main
        readme._isNew = false
        this.selectedId = created.id
      } else {
        const updated = await UserReadmeModel.updateReadme(readme.id, {
          title,
          content: readme.content,
          is_main: readme.is_main
        })
        readme.title = updated.title
        readme.updated_at = updated.updated_at
        readme.is_main = updated.is_main
      }

      if (readme.is_main) {
        this.readmes.forEach(r => {
          if ((r.id || r._tempId) !== this.selectedId) {
            r.is_main = false
          }
        })
      }

      this.showSavedMessage('保存しました')
      this.$emit('saved')
    } catch (e) {
      console.error('Failed to save readme:', e)
      alert('保存に失敗しました。再度お試しください。')
    } finally {
      this.isSaving = false
    }
  }

  closeModal() {
    this.$bvModal.hide('readme-modal')
  }
}
</script>

<style lang="scss" scoped>
.readme-modal-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.required-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  background: #fffef5;
  border: 1px solid #f5d433;
  border-radius: 8px;
  margin: 0 24px 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #1c1c1e;

  svg {
    flex-shrink: 0;
    margin-top: 1px;
  }
}

.readme-modal-desc {
  font-size: 14px;
  color: #798b96;
  margin: 0 24px 16px;
}

.readme-layout {
  display: flex;
  flex: 1;
  min-height: 380px;
  border-top: 1px solid #eef2f4;
}

.readme-sidebar {
  width: 240px;
  border-right: 1px solid #eef2f4;
  padding: 12px 0;
  flex-shrink: 0;
  overflow-y: auto;
}

.readme-sidebar-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  height: 48px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background 0.15s;
  border-left: 3px solid transparent;

  &:hover {
    background: #f8fafc;
  }

  &--active {
    background: #f0f6ff;
    border-left-color: #3b82f6;
  }
}

// セクション見出し（「組織コンテクスト」「個人コンテクスト」）
.readme-sidebar-section {
  padding: 14px 16px 6px;
  font-size: 11px;
  font-weight: 700;
  color: #798b96;
  letter-spacing: 0.4px;
}

// エディタ右の組織コンテクストread-only表示
.readme-org-notice {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #4a6b8a;
  background: #f3f6fb;
  border: 1px solid #c8d6e8;
  border-radius: 6px;
  line-height: 1.5;
}

.readme-title-readonly {
  padding: 12px 14px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 400;
  color: #1c1c1e;
  background: #fafafa;
  border: 1px solid #eef2f4;
  border-radius: 6px;
}

.readme-content-readonly {
  padding: 14px;
  font-size: 14px;
  line-height: 1.7;
  color: #1c1c1e;
  background: #fafafa;
  border: 1px solid #eef2f4;
  border-radius: 6px;
  white-space: pre-wrap;
  word-break: break-word;
  min-height: 280px;
}

// 「設定中 / 設定」ピルボタン（旧 星ボタン）
.readme-main-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 44px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  color: #798b96;
  background: #fff;
  border: 1px solid #d0d7de;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    color: #1d4ed8;
    border-color: #93c5fd;
    background: #eff6ff;
  }

  &--active {
    color: #fff;
    background: #3b82f6;
    border-color: #3b82f6;

    &:hover {
      color: #fff;
      background: #2563eb;
      border-color: #2563eb;
    }
  }
}

.readme-sidebar-item__icon {
  flex-shrink: 0;
}

.readme-sidebar-item__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.readme-sidebar-item__title {
  font-size: 13px;
  font-weight: 500;
  color: #1c1c1e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.readme-main-badge {
  display: inline-block;
  padding: 1px 6px;
  background: #3b82f6;
  color: #ffffff;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  width: fit-content;
}

.readme-add-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  width: calc(100% - 32px);
  margin: 8px 16px 0;
  padding: 8px 12px;
  background: none;
  border: 1px dashed #dae5ea;
  border-radius: 6px;
  font-size: 12px;
  color: #798b96;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #3b82f6;
    color: #3b82f6;
    background: #f0f6ff;
  }
}

.readme-editor {
  flex: 1;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
}

.readme-editor__inner {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
}

.readme-editor__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #798b96;
  font-size: 14px;
}

.readme-title-input {
  width: 100%;
  border: 1px solid #dae5ea;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  font-weight: 500;
  color: #1c1c1e;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #3b82f6;
  }

  &::placeholder {
    color: #aab4bc;
  }
}

.readme-textarea {
  width: 100%;
  flex: 1;
  border: 1px solid #dae5ea;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  line-height: 1.6;
  color: #1c1c1e;
  resize: none;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #3b82f6;
  }

  &::placeholder {
    color: #aab4bc;
  }
}

.readme-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-top: 1px solid #eef2f4;
}

.readme-footer__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

// 保存・設定完了の操作フィードバック
.readme-saved-message {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #16a34a;
}
.readme-saved-fade-enter-active,
.readme-saved-fade-leave-active {
  transition: opacity 0.3s;
}
.readme-saved-fade-enter,
.readme-saved-fade-leave-to {
  opacity: 0;
}

.readme-delete-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 14px;
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #fef2f2;
    border-color: #fca5a5;
  }
}

.readme-cancel-btn {
  padding: 8px 20px;
  background: #ffffff;
  border: 1px solid #dae5ea;
  border-radius: 8px;
  font-size: 14px;
  color: #1c1c1e;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f8fafc;
  }
}

.readme-save-btn {
  padding: 8px 24px;
  background: #3b82f6;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #2563eb;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
